import React from 'react'
import PropTypes from 'prop-types'

const RevertIcon = (props) => {
  const { color = '#00B2AD', classes = 'w-20' } = props
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M9 11.3365C8.45 11.3365 7.97917 11.1407 7.5875 10.749C7.19583 10.3574 7 9.88655 7 9.33655C7 8.78655 7.19583 8.31571 7.5875 7.92405C7.97917 7.53238 8.45 7.33655 9 7.33655C9.55 7.33655 10.0208 7.53238 10.4125 7.92405C10.8042 8.31571 11 8.78655 11 9.33655C11 9.88655 10.8042 10.3574 10.4125 10.749C10.0208 11.1407 9.55 11.3365 9 11.3365ZM9 18.3365C6.68333 18.3365 4.675 17.574 2.975 16.049C1.275 14.524 0.3 12.6199 0.05 10.3365H2.1C2.33333 12.0699 3.10417 13.5032 4.4125 14.6365C5.72083 15.7699 7.25 16.3365 9 16.3365C10.95 16.3365 12.6042 15.6574 13.9625 14.299C15.3208 12.9407 16 11.2865 16 9.33655C16 7.38655 15.3208 5.73238 13.9625 4.37405C12.6042 3.01571 10.95 2.33655 9 2.33655C7.85 2.33655 6.775 2.60321 5.775 3.13655C4.775 3.66988 3.93333 4.40321 3.25 5.33655H6V7.33655H0V1.33655H2V3.68655C2.85 2.61988 3.8875 1.79488 5.1125 1.21155C6.3375 0.628215 7.63333 0.336548 9 0.336548C10.25 0.336548 11.4208 0.574048 12.5125 1.04905C13.6042 1.52405 14.5542 2.16571 15.3625 2.97405C16.1708 3.78238 16.8125 4.73238 17.2875 5.82405C17.7625 6.91571 18 8.08655 18 9.33655C18 10.5865 17.7625 11.7574 17.2875 12.849C16.8125 13.9407 16.1708 14.8907 15.3625 15.699C14.5542 16.5074 13.6042 17.149 12.5125 17.624C11.4208 18.099 10.25 18.3365 9 18.3365Z"
        fill={color}
      />
    </svg>
  )
}

RevertIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(RevertIcon)
